import React, { Component } from "react";
// import {} from "react-router"; // Note this extra line
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
/************************* USERS SECTION ******************************/
import Books from "../screens/User/Books";
import Home from "../screens/User/Home";
import Downloads from "../screens/User/Downloads";
import Blogs from "../screens/User/Blogs";
import About from "../screens/User/About";
import NoMatch from "../screens/User/page404";
import Details from "../screens/User/details";
import Services from "../screens/User/Services";
import GetInTouch from "../screens/User/getInTouch";
import ProjectDetails from "../screens/User/projectDetails";
import VideoScreen from "../screens/User/videos";
/************************* USERS SECTION ******************************/
/************************* ADMIN SECTION ******************************/
import Admin from "../screens/Admin/Admin";
import Login from "../screens/Admin/Login";
import AddBlogs from "../screens/Admin/AddBlogs";
import EditBlog from "../screens/Admin/EditBlog";
import EditBooks from "../screens/Admin/EditBooks";
import EditProjects from "../screens/Admin/EditProjects";
import EditDownloads from "../screens/Admin/EditDownloads";
import AddDownloads from "../screens/Admin/AddDownloads";
import AddBooks from "../screens/Admin/AddBooks";
import addProjects from "../screens/Admin/AddProjects";
import AddBlogsDetails from "../screens/Admin/AddBlogsDetails";
/************************* ADMIN SECTION ******************************/
import ScrollToTop from "react-router-scroll-top";
import allprojects from "../screens/User/allProjects";
// import firebase from './firebase'
import { connect } from "react-redux";
import PrivateRoute from "./PrivateRoute";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      displayEmail: "",
    };
  }

  render() {
    // console.log("routes", this.props.user.user)

    return (
      <Router>
        <ScrollToTop>
          <Switch>
            {/* <Route exact path="/" component={All} /> */}
            <Route path="/" exact={true} component={Home} />
            <Route path="/Books" component={Books} />
            <Route path="/Downloads" component={Downloads} />
            <Route path="/allprojects" component={allprojects} />
            <Route path="/details" component={Details} />
            <Route path="/about" component={About} />
            <Route path="/contact" component={GetInTouch} />
            <Route path="/services" component={Services} />
            <Route path="/project-video" component={VideoScreen} />
            <Route path="/projectDetail/:id" component={ProjectDetails} />
            <PrivateRoute
              path="/Blogs"
              component={Blogs}
              authed={this.props.user}
            />
            <Route path="/AddblogsDetails/:id" component={AddBlogsDetails} />
            <Route exact path="/Login" component={Login} />
            {/* <Route exact path="/Admin" component={Admin} /> */}
            <PrivateRoute
              exact
              path="/Admin"
              component={Admin}
              authed={this.props.user}
            />
            <PrivateRoute
              exact
              path="/Blogs/:id"
              component={Blogs}
              authed={this.props.user}
            />
            <PrivateRoute
              exact
              path="/Addblogs"
              component={AddBlogs}
              authed={this.props.user}
            />
            <PrivateRoute
              exact
              path="/addprojects"
              component={addProjects}
              authed={this.props.user}
            />
            <PrivateRoute
              exact
              path="/Editblog/:id"
              component={EditBlog}
              authed={this.props.user}
            />
            <PrivateRoute
              exact
              path="/EditProjects/:id"
              component={EditProjects}
              authed={this.props.user}
            />
            <PrivateRoute
              exact
              path="/EditDownloads/:id"
              component={EditDownloads}
              authed={this.props.user}
            />
            <PrivateRoute
              exact
              path="/AddDownloads"
              component={AddDownloads}
              authed={this.props.user}
            />
            <PrivateRoute
              exact
              path="/Addbooks"
              component={AddBooks}
              authed={this.props.user}
            />
            <PrivateRoute
              exact
              path="/EditBooks/:id"
              component={EditBooks}
              authed={this.props.user}
            />
            <Route path="*" component={NoMatch} />
          </Switch>
        </ScrollToTop>
      </Router>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps, null)(Navbar);
